import { Popup } from "antd-mobile";

const FloatPopup = (props) => {
  const widthOfWindow = document.documentElement.clientWidth;
  const heightOfWindow = document.documentElement.clientHeight;
  const width = props.width;
  const ifMobile = widthOfWindow < heightOfWindow;
  const onMaskClick = props.onMaskClick;
  const onClose = props.onClose;
  const visible = props.visible;
  const children = props.children;
  const positionOfMobile = props.positionOfMobile
    ? props.positionOfMobile
    : "bottom";

  return (
    <Popup
      position={ifMobile ? positionOfMobile : "right"}
      onMaskClick={() => {
        onMaskClick();
      }}
      onClose={() => {
        onClose();
      }}
      visible={visible}
      bodyStyle={{
        height: ifMobile ? "auto" : heightOfWindow,
        width: ifMobile ? widthOfWindow : width,
        backgroundColor: "rgba(0, 0, 0, 0)",
        maxHeight: heightOfWindow * 0.85,
      }}
    >
      <div
        style={{
          padding: 10,
        }}
      >
        <div
          style={{
            overflowX: "hidden",
            overflowY: "hidden",
            backgroundColor: "#ffffff",
            borderRadius: 12,
            height: ifMobile ? "auto" : heightOfWindow - 20,
            width: ifMobile ? widthOfWindow - 20 : width - 20,
            maxHeight: ifMobile && heightOfWindow * 0.85,
          }}
        >
          <div
            style={{
              overflowY: "auto",
              overflowX: "hidden",
              height: ifMobile ? "auto" : heightOfWindow - 20,
              width: ifMobile ? widthOfWindow - 30 : width - 30,
              marginLeft: 15,
              maxHeight: ifMobile && heightOfWindow * 0.85 - 20,
              // marginTop:15,
            }}
          >
            <div
              style={{
                overflowY: "hidden",
                overflowX: "hidden",
                width: ifMobile ? widthOfWindow - 30 - 20 : width - 30 - 20,
                // marginLeft:15,
                // marginTop:15,
              }}
            >
              <div style={{ height: 15 }} />
              {children}
              <div style={{ height: 15 }} />
            </div>
          </div>
        </div>
      </div>
    </Popup>
  );
};
export default FloatPopup;
